import {useCallback} from 'react';

import {DmsDataGrid} from '@dms/shared';

import type {QueryFilterObject} from 'features/eag-grid';

interface ProbabiltyDataGridProps {
  serviceCaseId: string;
  orderId: string;
}

export function ProfitabilityDataGrid(props: ProbabiltyDataGridProps) {
  const queryModifier = useCallback(
    (filter: QueryFilterObject) => ({
      ...filter,
      orderId: props.orderId,
    }),
    [props.orderId]
  );

  return (
    <DmsDataGrid gridCode="service-order-profitability" autoHeight queryModifier={queryModifier} />
  );
}
